import React, { Component } from 'react'
import ReportEndpoints from '../../../api/ReportEndpoints';
import Api from '../../../api/Api.js';
import DataTable from '../../../components/Table/DataTable';
import moment from 'moment';
import Loading from '../../../components/Loading/Loading';
import FileDownloadHelper from '../../../helpers/FileDownloadHelper';


const columns = [
    {
        name: 'id',
        options: {
            filter: false,
            sort: false,
            download: false,
            print: false,
            display: "excluded"
        }
    },
    {
        name: "File",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Size",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "Date",
        options: {
            filter: true,
            sort: true,
        }
    }
];

class ReportHistory extends Component {
    options = {
        onRowClick: (row) => {
            Api.fileDownload(ReportEndpoints.download, { id: row[0] })
            .then(({ data }) => FileDownloadHelper(data, "application/zip", row[1] + '.zip'))
            .catch((e) => {
                console.error(e);
            })
        }
    };

    state = {
        loading: true,
        reports: []
    }

    componentDidMount() {
        Api.get(ReportEndpoints.history, { id: this.props.match.params.id }).then(({ data }) => this.setState({ reports: data, loading: false })).catch((e) => console.error(e));
    }

    render() {

        if(this.state.loading) {
            return <Loading />
        }

        return (
            <DataTable
                title={"Recent Reports"}
                data={this.state.reports.map(rep => [rep.id, rep.filename, rep.file_size, moment(rep.date).format('YYYY-MM-DD HH:mm')])}
                columns={columns}
                options={this.options}
                rowPointers
            />
        );
    }
}

export default ReportHistory